export { VTextarea } from './VTextarea'
